import React from 'react'
import moment from 'moment'

import NavLink from '../Routes/NavLink'

import { leases } from '../../core/controllers/Leases'

export default class CalendarWidget extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            events: null
        };
    }

    componentDidMount() {
        var self = this;
        leases.getExpiringLeasesForCurrentMonth(function(response) {
            const leaseData = response.additional;
            var events = [];

            for(var i = 0; i < leaseData.length; i++)
            {
                var lease = leaseData[i];
                events.push({
                    title: "Expiring Lease - " + lease.title,
                    start: new Date(lease.contract_expiration_date),
                    allDay: true,
                    backgroundColor: "#000a3d",
                    borderColor: "#000a3d",
                    id: lease.contract_data_id
                });
            }

            jQuery("#calendar-widget").fullCalendar({
				header: {
                    left: 'month,agendaWeek,agendaDay',
                    center: 'prev, title',
                    right: 'next'
				},
				buttonText: {
					month: 'Monthly',
					week: 'Weekly',
					day: 'Daily'
				},
				events: events,
				editable: false,
				droppable: false,
				drop: function (date, allDay) {
				},
				eventClick: function(calEvent, jsEvent, view) {
				}
			});
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        return (
            <div class="card">
                <div class="header red-header" style={{paddingTop:"0px"}}>
                    <h2 class="title text-center">
                        <div><span><i class="pe-7s-date" style={{fontWeight:"600", paddingRight:"10px"}}></i></span>Calendar</div></h2>
                </div>
                <div class="content">
                    <div class="row">
                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <div id="calendar-widget">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Calendar/CalendarWiget.jsx